import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import { assets } from "../../../assets/assets";
import ar from "../../../lang/ar";
import en from "../../../lang/en";
function FilterHome({
  lang,
  isOpen,
  onLandmarksClick,
  onRoadsClick,
  showPlaces,
  showRoads,
  isDevsActive,
  onDevsClick,
  onShowRadiusClick,
  hideShowRadius,
}) {
  const translations = lang === "ar" ? ar : en;
  const collapseRef = useRef(null);
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);
  const allActive = showPlaces && showRoads;
  const filters = [
    {
      icon: assets.showall,
      activeIcon: assets.showallActive,
      label: translations.showAll,
      type: "all",
    },
    {
      icon: assets.landmarks,
      activeIcon: assets.landmarksActive,
      label: translations.landmarks,
      type: "landmarks",
    },
    {
      icon: assets.roads,
      activeIcon: assets.roadsActive,
      label: translations.roads,
      type: "roads",
    },
    {
      icon: assets.building,
      activeIcon: assets.buildingActive,
      label: translations.developers,
      type: "devs",
    },
  ];
  useEffect(() => {
    if (!collapseRef.current || !contentRef.current) return;

    const updateHeight = () => {
      if (isOpen) {
        setHeight(contentRef.current.scrollHeight);
      } else {
        setHeight(0);
      }
    };

    updateHeight();
    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(contentRef.current);

    const mutationObserver = new MutationObserver(updateHeight);
    mutationObserver.observe(contentRef.current, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
    });

    return () => {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, [isOpen]);

  return (
    <div
      ref={collapseRef}
      className="filter-home-collapse col-10 col-md-6"
      style={{
        height: `${height}px`,
        overflow: "hidden",
        transition: "height 0.35s ease-in-out",
      }}
    >
      <div ref={contentRef} className="filter-home-content">
        <div className="card card-body bg-transparent p-0">
          <p className="p-0 title">Map Filter</p>
          <div className="filter-home-items">
            {filters.map((filter, index) => {
              const isActive =
                (filter.type === "landmarks" && showPlaces) ||
                (filter.type === "roads" && showRoads) ||
                (filter.type === "devs" && isDevsActive) ||
                (filter.type === "all" && allActive && isDevsActive);

              return (
                <div
                  key={index}
                  className={`filter-item-home col-auto ${isActive ? "active" : ""}`}
                  onClick={() => {
                    if (filter.type === "landmarks") onLandmarksClick?.();
                    if (filter.type === "roads") onRoadsClick?.();
                    if (filter.type === "devs") onDevsClick?.();

                    if (filter.type === "all") {
                      if (!(showPlaces && showRoads && isDevsActive)) {
                        onLandmarksClick?.(true);
                        onRoadsClick?.(true);
                        onDevsClick?.(true);
                      } else {
                        onLandmarksClick?.(false);
                        onRoadsClick?.(false);
                        onDevsClick?.(false);
                      }
                    }
                  }}
                >
                  {filter.icon && (
                    <img
                      src={isActive ? filter.activeIcon : filter.icon}
                      alt={filter.label}
                      style={{ width: "20px", height: "20px" }}
                    />
                  )}
                  <p
                    className="m-0 p-0"
                    style={{
                      color: isActive ? "white" : "#aaa",
                      fontWeight: isActive ? "600" : "400",
                    }}
                  >
                    {filter.label}
                  </p>
                </div>
              );
            })}
          </div>
          <div className="show-radius-check">
            <p className="m-0 p-0">show radius</p>
            <div class="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="switchCheckChecked"
                onClick={onShowRadiusClick}
                checked={hideShowRadius}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilterHome;
